export function iterateGridElements(rows, callback) {
    if('rows' in rows) { rows = rows.rows; }

    for (let targetName in rows) {
        if (!rows.hasOwnProperty(targetName)) { continue; }

        let row = rows[targetName];

        if(callback('row', row) === false) {
            return;
        }

        if(!row.name) {
            for(let col of row.cols) {
                if(callback('col', col) === false) {
                    return;
                }
                iterateGridElements(col.rows, callback);
            }
        }
    }
}

export function iterateGridTargets(rows, callback) {
    return iterateGridElements(rows, (type, obj) => {
        if(type === 'row' && obj.name) {
            return callback(obj.name);
        }
    });
}

export function getGridTargets(rows) {
    let targets = [];

    iterateGridTargets(rows, (name) => {
        targets.push(name); 
    });
    
    return targets;
}

export function hasTarget(rows, targetName) {
    let found = false;
    
    iterateGridTargets(rows, (name) => {
        if(name === targetName) {
            found = true;
            
            return false;
        } 
    });
    
    return found;
}